export { default } from './VinInfo';
